import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t> * + *:not(marquee) {\n\t\tmargin-left: -1px;\n\t\twidth: calc(100% + 1px);\n\t}\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t> * {\n\t\t&:focus-within {\n\t\t\tz-index: 1;\n\t\t}\n\t}\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-bottom-left-radius: 0;\n\tborder-top-left-radius: 0;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-radius: 0;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder-bottom-right-radius: 0;\n\tborder-top-right-radius: 0;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css } from '@wp-g2/styles';
export var first = css(_templateObject());
export var middle = css(_templateObject2());
export var last = css(_templateObject3());
export var firstRow = css(_templateObject4());
export var lastRow = css(_templateObject5());
export var itemFocus = css(_templateObject6());
export var itemGrid = css(_templateObject7());